import { supabase } from './supabaseClient';
import { getStoredSiteToken, clearSiteToken } from './authToken';
import { clearAdminToken } from './adminToken';
import { clearKanriCodeToken } from './kanriCodeToken';

let unauthorizedHandler = null;

/** App.jsから呼ぶ。サイト入場証が無効と分かったときに呼び出す先を登録する。 */
export function setUnauthorizedHandler(fn) {
  unauthorizedHandler = fn;
}

/**
 * supabase-jsは、Edge Functionが200以外を返すと invoke() の data を null にし、
 * 実際のエラー本文（{error, code}）は invokeError.context という Response
 * オブジェクトの中に入れてしまう。ここから本文を取り出す。
 */
async function readErrorBody(invokeError) {
  const context = invokeError?.context;
  if (!context || typeof context.clone !== 'function') return null;
  try {
    return await context.clone().json();
  } catch {
    return null;
  }
}

/**
 * Edge Function(gijiroku)を呼び出す共通ヘルパー。
 * 既定ではサイト入場証を自動で添付する。管理者操作など別のトークンを使いたい
 * ときは第3引数で明示的に上書きできる（例: callApi('save', body, adminToken)）。
 */
export async function callApi(action, body = {}, tokenOverride) {
  const token = tokenOverride !== undefined ? tokenOverride : getStoredSiteToken();
  const { data: okData, error: invokeError } = await supabase.functions.invoke('gijiroku', {
    body: { action, token, ...body },
  });

  const data = invokeError ? await readErrorBody(invokeError) : okData;

  if (!data) {
    throw new Error('サーバーに接続できませんでした。しばらくしてから、もう一度お試しください。');
  }
  if (data.error) {
    if (data.code === 'SITE_TOKEN_INVALID') {
      clearSiteToken();
      if (unauthorizedHandler) unauthorizedHandler();
    }
    if (data.code === 'ADMIN_TOKEN_INVALID') {
      clearAdminToken();
    }
    if (data.code === 'KANRI_CODE_TOKEN_INVALID') {
      clearKanriCodeToken();
    }
    const err = new Error(data.error);
    err.code = data.code;
    throw err;
  }
  return data;
}
